import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import reportService from "@/services/mrfiktiv/services/reportService";
import {
  MrfiktivReportControllerFindAllParamsGen,
  MrfiktivReportViewModelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, getModule } from "vuex-module-decorators";
import { ProgressStatusEnum } from "../enum/partner/progress.status.enum";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";
import { PartnerUserModule } from "./partner-user.store";

@Module({
  dynamic: true,
  namespaced: true,
  name: "reportPagination",
  store
})
export class ReportPaginationStore extends BasePagination<
  MrfiktivReportViewModelGen,
  MrfiktivReportControllerFindAllParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: MrfiktivReportViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;
  protected _filterList: IPaginationFilterListElement[] = [
    { key: "numberplate", type: FilterTypes.STRING, displayName: "objects.report.numberplate" },
    { key: "customerName", type: FilterTypes.STRING, displayName: "objects.report.customerName" },
    {
      key: "assignees",
      type: FilterTypes.OBJECT_ID,
      displayName: "objects.report.assignees",
      config: {
        items: PartnerUserModule.paginationList,
        mapItemToComponent: (item: any) => {
          return { item };
        },
        itemValue: "id",
        component: "refs-user"
      }
    },
    { key: "customerContact.email", type: FilterTypes.STRING, displayName: "objects.report.customerContact.email" },
    { key: "customerContact.phone", type: FilterTypes.STRING, displayName: "objects.report.customerContact.phone" },
    { key: "marketingOptIn", type: FilterTypes.BOOLEAN, displayName: "objects.report.marketingOptIn" },
    {
      key: "progressStatus",
      type: FilterTypes.ENUM,
      config: { items: Object.values(ProgressStatusEnum) },
      displayName: "objects.report.progressStatus"
    },

    {
      key: "registrationResults.firstregistrationDay",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.firstregistrationDay"
    },
    {
      key: "registrationResults.firstregistrationMonth",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.firstregistrationMonth"
    },
    {
      key: "registrationResults.firstregistrationYear",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.firstregistrationYear"
    },

    {
      key: "registrationResults.street",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.street"
    },
    {
      key: "registrationResults.zipCode",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.zipCode"
    },
    {
      key: "registrationResults.city",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.city"
    },
    {
      key: "registrationResults.huYear",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.huYear"
    },
    {
      key: "registrationResults.huMonth",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.huMonth"
    },
    {
      key: "registrationResults.manufacturerNameCode",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.manufacturerNameCode"
    },
    {
      key: "registrationResults.manufacturerTypeCode",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.manufacturerTypeCode"
    },
    {
      key: "registrationResults.driveTyp",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.driveTyp"
    },
    {
      key: "registrationResults.identificationnumber",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.identificationnumber"
    },
    {
      key: "registrationResults.numberplate",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.numberplate"
    },
    {
      key: "registrationResults.manufacturerName",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.manufacturerName"
    },
    {
      key: "registrationResults.manufacturerType",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.manufacturerType"
    },
    {
      key: "registrationResults.vehicleClass",
      type: FilterTypes.STRING,
      displayName: "objects.report.registrationResults.vehicleClass"
    },
    { key: "message", type: FilterTypes.STRING, displayName: "objects.report.message" },
    { key: "datePreference", type: FilterTypes.STRING, displayName: "objects.report.datePreference" },
    { key: "_id", type: FilterTypes.OBJECT_ID, displayName: "objects.report._id" }
  ];
  @Action
  protected async loadDocuments(query: MrfiktivReportControllerFindAllParamsGen): Promise<any> {
    const filter = [...(query.filter ?? [])];
    filter.push({ key: "progressStatus", value: ProgressStatusEnum.DELETED, operation: "$ne" });
    query.filter = filter;

    return reportService.getReportPaginated({
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      order: this.pageOrder,
      ...query
    });
  }
}

export const ReportPaginationModule = getModule(ReportPaginationStore);
